import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiMapPin, FiBook, FiX } = FiIcons;

const SearchFilters = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedGovernorate, setSelectedGovernorate] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('');

  const governorates = [
    'Amman', 'Irbid', 'Zarqa', 'Balqa', 'Mafraq', 'Jerash', 
    'Ajloun', 'Madaba', 'Karak', 'Tafilah', 'Maan', 'Aqaba'
  ];

  const supportTopics = [
    'Classroom Setup', 'Lesson Planning', 'STEM Integration', 
    'Programming Basics', 'World Building', 'Collaborative Projects',
    'Assessment Strategies', 'Technical Support', 'Curriculum Design'
  ];

  const handleSearch = () => {
    onSearch({
      searchTerm: searchTerm.trim(),
      governorate: selectedGovernorate,
      topic: selectedTopic
    });
  };

  const clearFilters = () => {
    setSearchTerm('');
    setSelectedGovernorate('');
    setSelectedTopic('');
    onSearch({
      searchTerm: '',
      governorate: '',
      topic: ''
    });
  };

  const hasActiveFilters = searchTerm || selectedGovernorate || selectedTopic;

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="expert-card"
    >
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Search Input */}
        <div className="relative">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
          />
        </div>

        {/* Governorate Filter */}
        <div className="relative">
          <SafeIcon icon={FiMapPin} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <select
            value={selectedGovernorate}
            onChange={(e) => setSelectedGovernorate(e.target.value)}
            className="w-full pl-10 pr-8 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 appearance-none bg-white"
          >
            <option value="">All Governorates</option>
            {governorates.map((gov) => (
              <option key={gov} value={gov}>{gov}</option>
            ))}
          </select>
        </div>

        {/* Topic Filter */}
        <div className="relative">
          <SafeIcon icon={FiBook} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <select
            value={selectedTopic}
            onChange={(e) => setSelectedTopic(e.target.value)}
            className="w-full pl-10 pr-8 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 appearance-none bg-white"
          >
            <option value="">All Topics</option>
            {supportTopics.map((topic) => (
              <option key={topic} value={topic}>{topic}</option>
            ))}
          </select>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-2">
          <button
            onClick={handleSearch}
            className="flex-1 btn-primary text-white px-4 py-3 rounded-lg font-medium flex items-center justify-center space-x-2"
          >
            <SafeIcon icon={FiSearch} />
            <span>Search</span>
          </button>
          
          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="px-4 py-3 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors flex items-center justify-center"
            >
              <SafeIcon icon={FiX} />
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SearchFilters;